import store from '@/state/store';

export default function onMessageMessageStatus(dataJson) {
  if (store.state.rooms.selectedRoomId !== dataJson.body.chat_id) return
  store.commit('room/UPDATE_MESSAGE_STATUS', dataJson.body);
}
